<template>
  <div class="ccui-app-iframe-no-operate-container">
    <breadcrumbSourcing :breadcrumb-data="breadcrumbData"></breadcrumbSourcing>
    <div class="ccui-app-iframe-container-no-operate-detail">
      <div class="ccui-app-iframe-container-detail-body">
        <div class="ccui-tab-iframe">
          <div class="ccui-tab-wrapper">
            <el-button
              :key="item.active"
              v-for="item in tabList"
              :type="
                activeName == item.active ? 'table-top-active' : 'table-top'
              "
              size="mini"
              @click="activeName = item.active"
              >{{ item.name }}</el-button
            >
          </div>
        </div>
        <template v-if="activeName == '1'">
          <el-form :model="form" ref="form" label-width="120px">
            <el-row>
              <el-col :span="12">
                <el-form-item label="评标室名称：">
                  <span>{{ form.evaRoomName }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="预计总评标时间：">
                  <span>{{ form.hadTime }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="评标开始时间：">
                  <span>{{ form.evaStartTime }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="预计评标结束时间：">
                  <span>{{ form.evaEndTime }}</span>
                  <div class="evaTimeTip">
                    (评标结束时间实际以评标室组长“生效评标报告为准”)
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="评标方法：">
                  <span>{{ form.evaMethodStr }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="是否符合性检查：">
                  <span>{{ form.conformCheckFlagStr }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <template v-if="form.evaMethod == '102'">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="评标形式：">
                    <span>{{ form.evaFormStr }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </template>
          </el-form>
        </template>
        <template v-if="activeName == '2'">
          <el-table :data="fileData" border class="dic-sub-table-style01">
            <el-table-column
              type="index"
              width="50"
              label="序号"
            ></el-table-column>
            <el-table-column
              property="fileName"
              label="附件名称"
              show-overflow-tooltip
              width="130"
            ></el-table-column>
            <el-table-column
              property="fileSize"
              label="附件大小"
              show-overflow-tooltip
              width="130"
            >
              <template slot-scope="{ row }">
                <span>{{ row.fileSize }}K</span>
              </template>
            </el-table-column>
            <el-table-column
              property="fileSumm"
              label="附件说明"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              property="createTime"
              label="上传时间"
              show-overflow-tooltip
              width="170"
            ></el-table-column>
            <el-table-column label="操作" width="80">
              <template slot-scope="{ row }">
                <el-button type="text" @click="download(row)">下载</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
        <div class="ccui-tab-iframe">
          <div class="ccui-tab-wrapper">
            <el-button type="table-top-active" size="mini">评标专家</el-button>
          </div>
        </div>
        <el-table class="dic-sub-table-style01" :data="expertData" border>
          <el-table-column
            type="index"
            :width="commonTableWidth.serialNoWidth"
            label="序号"
          ></el-table-column>
          <el-table-column
            property="expertSourceStr"
            label="专家来源"
            show-overflow-tooltip
            :width="commonTableWidth.expertSource"
          >
            <template slot-scope="{ row }">
              {{ row.expertSource == "0" ? "随机抽取" : "单位委派" }}
            </template>
          </el-table-column>
          <el-table-column
            property="expertName"
            label="专家姓名"
            show-overflow-tooltip
            :width="commonTableWidth.expertName"
          ></el-table-column>
          <el-table-column
            property="expertRoleStr"
            label="专家角色"
            show-overflow-tooltip
            :width="commonTableWidth.expertRole"
          >
            <template slot-scope="{ row }">
              {{
                row.expertRole == "0"
                  ? "评标专家"
                  : row.expertRole == "2"
                  ? "招标人代表"
                  : "评标组长"
              }}
            </template>
          </el-table-column>
          <el-table-column
            property="professional"
            label="专家特长"
            show-overflow-tooltip
            min-width="130"
          ></el-table-column>
          <el-table-column
            property="workUnitName"
            label="工作单位"
            min-width="130"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            property="signFlag"
            label="签到情况"
            show-overflow-tooltip
            :width="commonTableWidth.fourTitle"
          ></el-table-column>
          <el-table-column
            property="signTime"
            label="签到时间"
            show-overflow-tooltip
            :width="commonTableWidth.dateTimeWidth"
          ></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import breadcrumbSourcing from "@/app/sourcingFlow/components/breadcrumb-sourcing.vue";
import {
  qryBidEvaPrepareDetailApi,
  qryJoinExpertListApi,
  qryFileinfoListForEva
} from "@/app/sourcingFlow/api/expertEvaluation.js";
import { addUrlPerFix } from "@/basa/utils";
import { commonTableWidth } from "@/setting/setting.js";
export default {
  name: "sourcingFlow",
  components: {
    breadcrumbSourcing
  },
  data() {
    return {
      commonTableWidth: commonTableWidth,
      labelType:
        JSON.parse(sessionStorage.getItem("expertSourceData")).evaStatus === "2"
          ? "evaluation"
          : JSON.parse(sessionStorage.getItem("expertSourceData")).evaStatus ===
            "3"
          ? "evaluationEnds"
          : "evaluationEnds", // 评标中：evaluation 评标结束：evaluationEnds
      breadcrumbData: {
        titname: "专家评标",
        status: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .evaStatusStr
      },
      activeName: "1",
      form: {
        hadTime: "00天 00小时 00分钟"
      },
      fileData: [],
      expertData: [],
      tabList: [
        {
          name: "评标项目",
          active: "1"
        },
        {
          name: "相关附件",
          active: "2"
        }
      ],
      relationWarningList: [],
      purchaseType: JSON.parse(sessionStorage.getItem("expertSourceData"))
        .purchaseType
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      qryBidEvaPrepareDetailApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId
      }).then(res => {
        this.form = res.data.data;
        this.getHadTime(this.form.evaStartTime, this.form.evaEndTime);
        sessionStorage.setItem(
          "bidEvaPrepareDetailData",
          JSON.stringify(this.form)
        );
        qryFileinfoListForEva({
          // schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          //   .schemeId,
          // billId: this.form.bidEvaId,
          // billType: "0800",
          // uploadPhase: "0800"
          uploadPhases: ["1", "14", "0201", "0203", "0301", "102", "0800"],
          billIdOrParentBillId: JSON.parse(
            sessionStorage.getItem("expertSourceData")
          ).schemeId
        }).then(res => {
          this.fileData = res.data.data;
        });
      });
      qryJoinExpertListApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        pageNo: 1,
        pageSize: 100
      }).then(res => {
        this.expertData = res.data.data.rows;
      });
    },
    getHadTime(startTime, endTime) {
      if (startTime && endTime) {
        let start = startTime;
        let end = endTime;
        start = start.split("-").join("/");
        end = end.split("-").join("/");
        let time = new Date(end).getTime() - new Date(start).getTime();
        let date = parseInt(time / (24 * 60 * 60 * 1000));
        let hadTime;
        let hours;
        let minutes;
        (!date || date < 0) && (date = 0);
        hours = parseInt(
          (time - date * (24 * 60 * 60 * 1000)) / (60 * 60 * 1000)
        );
        (!hours || hours < 0) && (hours = 0);
        minutes = parseInt(
          (time - date * (24 * 60 * 60 * 1000) - hours * (60 * 60 * 1000)) /
            (60 * 1000)
        );
        (!minutes || minutes < 0) && (minutes = 0);
        date < 10 && (date = "0" + date);
        hours < 10 && (hours = "0" + hours);
        minutes < 10 && (minutes = "0" + minutes);
        hadTime = date + "天 " + hours + "小时 " + minutes + "分钟";
        this.form.hadTime = hadTime;
      }
    },
    download(row) {
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      openUrl.href = `${addUrlPerFix(
        process.env.VUE_APP_BASE_URL
      )}/apis/bid/oss/downloadByUploadId?fileUrl=${
        row.fileUrl
      }&fileName=${encodeURIComponent(row.fileName)}`;
      openUrl.setAttribute("download", row.fileName);
      document.body.appendChild(openUrl);
      openUrl.click();
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .el-table td {
  height: 36px !important;
  line-height: 36px !important;
}
</style>
<style>
.ccui-top-bar-wrapper {
  display: none;
}
.evaTimeTip {
  color: #ff142f;
  position: absolute;
  left: 138px;
  top: 0;
  padding-top: 6px;
  line-height: 18px;
}
</style>
